//test
export const increment = ({commit}) => {
    commit('INCREMENT')
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js